import { on, select, selectAll, replace, getHeight, getTopPosition, scrollTop, addClass, removeClass, hasClass, getScrollTop } from 'modules/dom'
import { map } from 'modules/utils'

const body = document.body
const BODY_NAV_CLASS = 'is-sticky-resource-nav'
const BODY_ADMIN_CLASS = 'admin-bar'
const ACTIVE_NAV_CLASS = 'single-resource__anchor--active'
const HEADER_FIX_CLASS = 'js-header-fixed'

export default function (el) {
    const globalHeader = select('.header')
    const globalHeaderHeight = getHeight(globalHeader)
    const scrollNavItem = selectAll('a.js-scroll-trigger[href*="#"]:not([href="#"])', el)
    const initialElScrollPosition = getTopPosition(el) - 2 * globalHeaderHeight
    if (scrollNavItem.length) {
        map(function (anchor) {
            on('click', function (e) {
                e.preventDefault()
                removeClass(ACTIVE_NAV_CLASS, scrollNavItem)
                addClass(ACTIVE_NAV_CLASS, anchor)
                if (location.pathname.replace(/^\//, '') === anchor.pathname.replace(/^\//, '') && location.hostname === anchor.hostname) {
                    let target = anchor.hash
                    target = target.length ? target : ('[name=' + anchor.hash.slice(1) + ']')
                    target = select(target)
                    if (target) {
                        let targetScrollTop = getScrollTop() + target.getBoundingClientRect().top - getHeight(el)
                        if (!hasClass(BODY_NAV_CLASS, body)) {
                            if (!hasClass(HEADER_FIX_CLASS, globalHeader)) {
                                targetScrollTop -= globalHeaderHeight + getHeight(el)
                            } else {
                                targetScrollTop -= getHeight(el)
                            }
                        }
                        if (hasClass(BODY_ADMIN_CLASS, body)) {
                            targetScrollTop -= 32
                        }
                        scrollTop(targetScrollTop, undefined, undefined)
                    }
                }
            }, anchor)
        }, scrollNavItem)
    }
    on('scroll', function() {
        let isStickyNav = getScrollTop() > initialElScrollPosition
        isStickyNav ? addClass(BODY_NAV_CLASS, body) : removeClass(BODY_NAV_CLASS, body)
    }, window)
}
